import React from 'react';

import withWidth from '@material-ui/core/withWidth';
import { Box, Typography, Paper } from "@material-ui/core"

const paddings = {
    xs: 2,
    sm: 2,
    md: 4,
    lg: 8,
};
const ResponsiveBox = withWidth()(({ children, width }) => {
    return <Box p={paddings[width]}>{children}</Box>
})

export default ({
    title,
    children
}) => {
    return (
        <Paper>
            <ResponsiveBox >
                <div>
                    <Typography variant="h3" gutterBottom>{title}</Typography>
                    {children}
                </div>
            </ResponsiveBox>
        </Paper>
    )
}